import { trainingSettingRegistrations } from '../settings/training-setting-definitions.js';
import { trainingModuleManifest } from '../training.module.js';
import { trainingTimesheetSummaryHostCapability, trainingTimesheetSummaryHostSlot, } from '../contracts/training-timesheet-summary-host.contract.js';
import { trainingWorkforceProfileHostCapability, trainingWorkforceProfileHostSlot, } from '../contracts/training-workforce-profile-host.contract.js';
export const trainingWebModuleContribution = {
    moduleId: 'training',
    manifest: trainingModuleManifest,
    settingRegistrations: trainingSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [
        {
            id: 'training.web.timesheets.activity-summary',
            moduleId: 'training',
            slot: trainingTimesheetSummaryHostSlot,
            contractVersion: trainingTimesheetSummaryHostCapability,
            requiredPermission: 'training.activity.read-private',
            settingCondition: {
                key: 'training.display.timesheet-summary',
                property: 'enabled',
                equals: true,
            },
            priority: 50,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./training-timesheet-summary.panel.js'),
        },
        {
            id: 'training.web.workforce.profile-status',
            moduleId: 'training',
            slot: trainingWorkforceProfileHostSlot,
            contractVersion: trainingWorkforceProfileHostCapability,
            requiredPermission: 'training.profile-status.read-all',
            settingCondition: {
                key: 'training.display.workforce-profile-status',
                property: 'enabled',
                equals: true,
            },
            priority: 60,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./training-workforce-profile-status.panel.js'),
        },
    ],
    routes: [
        {
            id: 'training.web.center', moduleId: 'training', path: '/training',
            requiredPermission: 'training.catalog.read',
            navigation: {
                id: 'training.navigation.center', fallbackLabel: 'Training',
                labelConfigurationKey: 'training.copy.learning',
                labelValueProperty: 'navigationLabel', priority: 82,
            },
            load: () => import('./training-center.page.js'),
        },
        {
            id: 'training.web.course', moduleId: 'training', path: '/training/courses/:courseId',
            requiredPermission: 'training.catalog.read', navigation: null,
            load: () => import('./training-lesson.page.js'),
        },
        {
            id: 'training.web.assessment', moduleId: 'training', path: '/training/courses/:courseId/assessment',
            requiredPermission: 'training.learning.complete', navigation: null,
            load: () => import('./training-assessment.page.js'),
        },
        {
            id: 'training.web.management', moduleId: 'training', path: '/training/manage',
            requiredPermission: 'training.content.manage',
            navigation: {
                id: 'training.navigation.management', fallbackLabel: 'Training management',
                labelConfigurationKey: 'training.copy.management',
                labelValueProperty: 'managementNavigationLabel', priority: 83,
            },
            load: () => import('./training-content-admin.page.js'),
        },
        {
            id: 'training.web.grades', moduleId: 'training', path: '/training/grades',
            requiredPermission: 'training.grades.read-all',
            navigation: {
                id: 'training.navigation.grades', fallbackLabel: 'Training grades',
                labelConfigurationKey: 'training.copy.management',
                labelValueProperty: 'gradesNavigationLabel', priority: 84,
            },
            load: () => import('./training-grades.page.js'),
        },
        {
            id: 'training.web.certifications', moduleId: 'training', path: '/training/certifications',
            requiredPermission: 'training.certifications.read-own',
            navigation: {
                id: 'training.navigation.certifications', fallbackLabel: 'Professional certifications',
                labelConfigurationKey: 'training.copy.certifications',
                labelValueProperty: 'navigationLabel', priority: 85,
            },
            load: () => import('./training-certifications.page.js'),
        },
    ],
};
export default trainingWebModuleContribution;
//# sourceMappingURL=training-web.module-contribution.js.map